interface RoundedContainerProps {
  children: React.ReactNode
  className?: string
  style?: 'light' | 'dark',
  doubleRounded?: boolean,
  numberOfCircles?: number
}

export const RoundedContainer: React.FC<RoundedContainerProps> = ({ children, className, style = 'light', doubleRounded = false, numberOfCircles = 3 }) => {
  return (
    <section className={`
      ${style === 'dark' ? 'bg-[#111821] overflow-hidden' : 'bg-gray-100'}
      text-[#151D28]
      ${doubleRounded ? 'rounded-[30px] md:rounded-[60px]' : 'rounded-[30px] rounded-b-none md:rounded-b-none md:rounded-[60px]'}
      relative
      ${className}
    `}>
      { style === 'dark' &&
        <>
          {Array.from({ length: numberOfCircles }).map((_, index) => {
            const i = index + 1
            const top = i * -500
            const left = i * 400
            const bottom = i * 500
            const right = i * -400

            return (
              <div key={i} className={`gradient-circle top-[${top}px] left-[${left}px] bottom-[${bottom}px] right-[${right}px] w-[1500px] h-[1500px]`}></div>
            )
          })}
        </>
      }
      {children}
    </section>
  )
}
